export * from "./globals";
export * from "./core";
export * from "./components";
export * from "./actions/api";
export * from "./ui";
export * from "../styles";
export * from "../deps";

import globals from "./globals";
import { ready, BU } from "./core";
import * as Components from "./components";

/** @type {any} */ (globals).BU = BU;
BU.types = Components;

ready(() => {
	console.log("document ready");
});
